import React from 'react'

const Footer = () => {
  return (
    <footer>
      <hr />
      <p>&#169;2022 by <a href="mailto:saralie.bognandi@gmail.com">Saralie</a> and <a href="mailto:younas.tesfamaria@outlook.com">Younas</a></p>
      <p>
        Team Foxes
        <span role="img" aria-label="fox emoji">
          &nbsp;🦊&nbsp;
        </span>
        | Technigo
      </p>
    </footer>
  );
};

export default Footer;